module.exports = __webpack_public_path__ + "img/s2.ddbb878d.jpg";